import React, {useContext} from 'react'
import {Route} from "react-router";
import {AppContext} from "../../context/app-context";
import {useFeatureFlags} from '../../hooks/routing/useFeatureFlags';
import {withAccessControl} from "../ProtectedRoute";
import AccessControlBuilder from "../AccessControlBuilder";

import SupplierActiveBookingsLegacy from "../../views/SupplierActiveBookingsLegacy";
import LegacySupplierInterchangeReport from "../../views/LegacySupplierInterchangeReport";
import SupplierInterchangeReport from '../../views/SupplierInterchangeReport';
import SupplierActivitySummaryReport from "../../views/supplier/SupplierActivitySummaryReport";
import CheckInLegacy from "../../views/CheckInLegacy";
import SupplierBookingCheckInReport from "../../views/supplier/SupplierBookingCheckInReport";
import SupplierCurrentInventoryReport from "../../views/supplier/SupplierCurrentInventoryReport";
import SupplierInventoryReport from '../../views/SupplierInventoryReport'
import SupplierPendingInventoryActivityReport from '../../views/supplier/SupplierPendingInventoryActivityReport'

const allSupplierGmsAuthorization = new AccessControlBuilder().allowAllGmsUsers().build()

const ProtectedSupplierActiveBookingsLegacy = withAccessControl(SupplierActiveBookingsLegacy, allSupplierGmsAuthorization)
const ProtectedCheckInLegacy = withAccessControl(CheckInLegacy, allSupplierGmsAuthorization)
const ProtectedSupplierBookingCheckInReport = withAccessControl(SupplierBookingCheckInReport, allSupplierGmsAuthorization)
const ProtectedSupplierInventoryReport = withAccessControl(SupplierCurrentInventoryReport, allSupplierGmsAuthorization)
const ProtectedLegacySupplierCurrentInventoryReport = withAccessControl(SupplierInventoryReport, allSupplierGmsAuthorization)
const ProtectedOldSupplierInterchangeReport = withAccessControl(LegacySupplierInterchangeReport, allSupplierGmsAuthorization)
const ProtectedSupplierInterchangeReport = withAccessControl(SupplierInterchangeReport, allSupplierGmsAuthorization)
const ProtectedSupplierActivitySummaryReport = withAccessControl(SupplierActivitySummaryReport, allSupplierGmsAuthorization)
const ProtectedSupplierPendingInventoryActivityReport = withAccessControl(SupplierPendingInventoryActivityReport, allSupplierGmsAuthorization)

const GateManagementContent = (): React.ReactElement<any>[] => {
  const appContext = useContext(AppContext)
  const {logout} = appContext

  const {
    supplierInterchangeRedesign,
    supplierCurrentInventoryRedesign,
    supplierCheckInRedesign,
    supplierPendingInventoryActivity
  } = useFeatureFlags();

  const flagGatedRoutes = [];
  if (supplierPendingInventoryActivity) {
    flagGatedRoutes.push(
      <Route path={"/supplier-pending-inventory-activity"} key={"/supplier-pending-inventory-activity"} element={
        <ProtectedSupplierPendingInventoryActivityReport handleLogout={logout}/>
      }/>
    )
  }

  return [
    <Route path="/check-in" key="/check-in" element={
              supplierCheckInRedesign ? <ProtectedSupplierBookingCheckInReport />
              : <ProtectedSupplierActiveBookingsLegacy handleLogout={logout}/>}>
    </Route>,
    <Route path="/check-in/:bookingId" key="/check-in/bookingId" element={
              <ProtectedCheckInLegacy handleLogout={logout}/>}>
    </Route>,
    <Route path="/supplier-inventory" key="/supplier-inventory" element={
              supplierCurrentInventoryRedesign ? <ProtectedSupplierInventoryReport handleLogout={logout}/>
              : <ProtectedLegacySupplierCurrentInventoryReport handleLogout={logout}/>}>
    </Route>,
     <Route path={"/supplier-interchanges"} key={"/supplier-interchanges"} element={
              supplierInterchangeRedesign ? <ProtectedSupplierInterchangeReport handleLogout={logout}/> :
              <ProtectedOldSupplierInterchangeReport handleLogout={logout}/>
     }/>,
    <Route path="/supplier-activity-summary" key="/supplier-activity-summary"
           element={<ProtectedSupplierActivitySummaryReport handleLogout={logout}/>}>
    </Route>,
    ...flagGatedRoutes
  ]
}

export default GateManagementContent
